import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';

import RequestDateBlockData from './Data';
import RequestDateBlockView from './View';

const RequestDateBlockEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  return (
    <>
      <RequestDateBlockView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <RequestDateBlockData
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(RequestDateBlockEdit);
